import { render, staticRenderFns } from "./ProductGroupDropdowns.vue?vue&type=template&id=625e006a&"
import script from "./ProductGroupDropdowns.vue?vue&type=script&lang=js&"
export * from "./ProductGroupDropdowns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports